import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Avatar,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  EventNote as AppointmentsIcon,
  Article as BlogsIcon,
  LocalHospital as SpecialitiesIcon,
  QuestionAnswer as QueriesIcon,
  Logout as LogoutIcon,
  Person as PersonIcon,
  EditCalendar as CalendarIcon,
} from "@mui/icons-material";
import logo from "../assets/logo.png";
import NotificationMenu from "./NotificationMenu";
import { useAuth } from "../context/AuthContext";

const drawerWidth = 240;

const theme = createTheme({
  palette: {
    primary: {
      main: "#12b48b",
    },
  },
});

const menuItems = [
  { text: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
  {
    text: "Appointments",
    icon: <AppointmentsIcon />,
    path: "/appointments",
    adminOnly: true,
  },
  {
    text: "Slot Manage",
    icon: <CalendarIcon />,
    path: "/slots",
    adminOnly: true,
  },
  { text: "Blogs", icon: <BlogsIcon />, path: "/blogs" },
  // { text: "Specialities", icon: <SpecialitiesIcon />, path: "/specialities" },
  // { text: "Queries", icon: <QueriesIcon />, path: "/queries" },
];

const Layout = ({ children }) => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const visibleMenuItems = menuItems.filter(
    (item) => !item.adminOnly || user?.role === "admin"
  );

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const drawer = (
    <div>
      <Toolbar sx={{ justifyContent: "center", py: 2, bgcolor: "#204066" }}>
        <img
          src={logo}
          alt="PEH Logo"
          style={{
            width: "120px",
            height: "auto",
          }}
        />
      </Toolbar>
      <Divider />
      <List sx={{ bgcolor: "#204066" }}>
        {visibleMenuItems.map((item) => (
          <ListItem
            button
            key={item.text}
            onClick={() => navigate(item.path)}
            selected={location.pathname === item.path}
            sx={{
              "&.Mui-selected": {
                bgcolor: "rgba(255, 255, 255, 0.1)",
                "&:hover": {
                  bgcolor: "rgba(255, 255, 255, 0.2)",
                },
                "& .MuiListItemIcon-root": {
                  color: "white",
                },
                "& .MuiListItemText-primary": {
                  color: "white",
                },
              },
              "&:hover": {
                bgcolor: "rgba(255, 255, 255, 0.1)",
              },
              "& .MuiListItemIcon-root": {
                color: "white",
              },
              "& .MuiListItemText-primary": {
                color: "white",
              },
            }}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
      <Divider />
      <List sx={{ bgcolor: "#204066" }}>
        <ListItem
          button
          onClick={handleLogout}
          sx={{
            "&:hover": {
              bgcolor: "rgba(255, 255, 255, 0.1)",
            },
            "& .MuiListItemIcon-root": {
              color: "white",
            },
            "& .MuiListItemText-primary": {
              color: "white",
            },
          }}
        >
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItem>
      </List>
    </div>
  );

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex" }}>
        <AppBar
          position="fixed"
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
            bgcolor: "#12b48b",
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, color: "white" }}
            >
              {menuItems.find((item) => item.path === location.pathname)
                ?.text || "Dashboard"}
            </Typography>
            {/* <NotificationMenu /> */}
          </Toolbar>
        </AppBar>
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        >
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                bgcolor: "#204066",
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                bgcolor: "#204066",
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            mt: "64px",
          }}
        >
          {children}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Layout;
